// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"E5-z","categoryName":"F5-z","categoryImage":"G5-z","categoryContent":"H5-z","bottomAligned":"I5-z"};